/**
 * Filter field which filters feature lists.
 *
 * Element directive used to add a filter at the top of feature lists
 * <list-filter placeholder="Filter by Funnel name" module="funnels"></list-filter>
 *
 * Used in combination with pagination:
 * <list-filter
 *      placeholder="Filter by Heatmap name or targeted URL"
 *      use-paging="true"
 *      module="heatmaps">
 * </list-filter>
 *
 */
angular.module('hjApp').directive('listFilter', [
    function () {
        return {
            restrict: 'E',
            replace: true,
            template: require('../../html/directives/list-filter.html'),
            link: function ($scope, element, attrs) {
                var cachedSearchResult = [],
                    cachedList = [],
                    filterString = '';

                $scope.filter = '';
                $scope.filterOn = 'name';
                $scope.module = attrs.module;
                $scope.placeholder = attrs.placeholder;
                $scope.usePaging = attrs.usePaging;
                $scope.filterOptions = getFilterOptions();

                // Return true if the text contains the value.
                function contains(text, value) {
                    return text.toLowerCase().indexOf(value.toLowerCase()) > -1;
                }

                /**
                 * Return the filtered list.
                 */
                $scope.getFilteredList = function (ignorePaging) {
                    var shouldReFilter =
                        _.isEqual(cachedList, $scope.model[$scope.module]) || $scope.filter != filterString;

                    cachedList = $scope.model[$scope.module];

                    if (shouldReFilter) {
                        filterString = $scope.filter;
                        // Return a match if the filter matches any property.
                        switch ($scope.module) {
                            // A custom hook for react implementation of this functionality
                            // can be found in (src/webapp/hooks/useOrganizationFilter.ts)
                            case 'organizations':
                                cachedSearchResult = _.sortBy(
                                    _.filter(cachedList, function (organization) {
                                        return (
                                            contains(organization.name, filterString) ||
                                            _.find(organization.sites, function (site) {
                                                return (
                                                    contains(site.name, filterString) ||
                                                    contains(site.url, filterString)
                                                );
                                            })
                                        );
                                    }),
                                    function (organization) {
                                        return organization.name;
                                    }
                                );
                                break;
                            case 'users':
                                cachedList = $scope.model['organizations'];
                                cachedList.forEach(function (item) {
                                    if (item.originalUsers) {
                                        item.users = item.originalUsers;
                                    }
                                });

                                if ($scope.filterOn === 'organization') {
                                    cachedSearchResult = _.sortBy(
                                        _.filter(cachedList, function (organization) {
                                            return contains(organization.name, filterString);
                                        }),
                                        'name'
                                    );
                                } else {
                                    cachedSearchResult = _.sortBy(
                                        _.filter(cachedList, function (organization) {
                                            return _.find(organization.users, function (user) {
                                                return contains(user[$scope.filterOn], filterString);
                                            });
                                        }),
                                        'name'
                                    );

                                    // Filter the users in an organisation based on the search string.
                                    cachedSearchResult.forEach(function (result) {
                                        if (!result.originalUsers) {
                                            result.originalUsers = result.users;
                                        }

                                        result.users = result.originalUsers.filter(function (user) {
                                            return contains(user[$scope.filterOn], filterString);
                                        });
                                    });
                                }
                                break;
                            default:
                                cachedSearchResult = _.filter(cachedList, function (item) {
                                    return contains(item[$scope.filterOn], filterString);
                                });
                                break;
                        }
                    }

                    // If paging is switched on, slice and dice the array to only return the current page.
                    if ($scope.usePaging && !ignorePaging) {
                        return cachedSearchResult.slice(
                            ($scope.currentPage - 1) * $scope.itemsPerPage,
                            $scope.currentPage * $scope.itemsPerPage
                        );
                    }

                    return cachedSearchResult;
                };

                /**
                 * Reset the filter field.
                 */
                $scope.resetFilter = function () {
                    $scope.filter = '';
                };

                /**
                 * Loads the options for the dropdown when a module have multiple options to search in.
                 *
                 * This is currently hard-coded into module due to this directive being heavily intertwined with the
                 * parent controller.
                 */
                function getFilterOptions() {
                    switch ($scope.module) {
                        case 'users':
                            return [
                                {
                                    key: 'name',
                                    label: 'Filter by Name'
                                },
                                {
                                    key: 'email',
                                    label: 'Filter by Email'
                                },
                                {
                                    key: 'organization',
                                    label: 'Filter by Organization'
                                }
                            ];
                    }
                    return [];
                }

                if (_.isUndefined($scope.getTotalCount)) {
                    $scope.getTotalCount = function () {
                        return $scope.getFilteredList(true).length;
                    };
                }
            }
        };
    }
]);
